module.exports = __webpack_public_path__ + "img/selectdataseries-image7.8824ccc1.png";